module.exports = __webpack_public_path__ + "img/18.c41c9482.jpg";